import { RouteRecordRaw } from "vue-router";

export const register: RouteRecordRaw = {
  path: "/register",
  component: () =>
    import(/* webpackChunkName: "register" */ "@/layouts/Default.vue"),
  children: [
    {
      path: "set-worker-service",
      name: "RegisterSetWorkerservice",
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/register/SetWorkerService.vue"
        )
    },
    {
      path: "personal-info",
      name: "RegisterPersonalInfo",
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/register/PersonalInfo.vue"
        )
    },
    {
      path: "business-info",
      name: "RegisterBusinessInfo",
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/register/BusinessInfo.vue"
        )
    },
    {
      path: "set-qualification",
      name: "RegisterSetQualification",
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/register/SetQualification.vue"
        )
    },
    {
      path: "set-bank",
      name: "RegisterSetBank",
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/register/SetBank.vue"
        )
    },
    {
      path: "finish-signup",
      name: "RegisterFinishSignup",
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/register/FinishSignup.vue"
        )
    }
  ]
};

/**
 * カメラ起動画面のみレイアウトが大きく変わるため、別ルーティングとしている
 */
export const cameraRegister: RouteRecordRaw = {
  path: "/register",
  component: () =>
    import(/* webpackChunkName: "applications" */ "@/layouts/Default.vue"),
  props: { isBackgroundTransparent: true },
  children: [
    {
      path: "set-avatar",
      name: "RegisterSetAvatar",
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/register/SetAvatar.vue"
        )
    },
    {
      path: "set-id",
      name: "RegisterSetId",
      component: () =>
        import(/* webpackChunkName: "register" */ "@/views/register/SetId.vue")
    },
    {
      path: "add-qualification",
      name: "RegisterAddQualification",
      component: () =>
        import(
          /* webpackChunkName: "register" */ "@/views/register/AddQualification.vue"
        )
    }
  ]
};
